<template>
    <div id="codename-main">
        <v-container v-if="!search">
            <v-text-field
                    outlined
                    label="Entrer un code secret"
                    v-model="codeInput"
                    :hint="codeSemblables"
                    clearable
            >
            </v-text-field>

            <v-slide-y-transition>
                <v-row justify="center" align="center" v-show="codeInput.length>0">
                    <div class="mr-5">Nombre de mots:</div>
                    <v-btn-toggle
                            active-class="primary"
                            mandatory
                            v-model="codeNumber">
                        <v-btn v-for="i of 9" :key="`witness-${i}`">{{i}}</v-btn>
                    </v-btn-toggle>
                </v-row>
            </v-slide-y-transition>

            <v-slide-y-transition>
                <v-row justify="center" class="mt-5" v-show="codeInput.length>0 && codeNumber>=0 && codeSemblables===''">
                    <v-btn color="success">Valider le code</v-btn>
                </v-row>
            </v-slide-y-transition>
        </v-container>
        <v-container v-else>
            <v-row class="flex-column">
                <v-col>Code: {{codeSearch}}</v-col>
                <v-col>Nombre: {{codeFound}}/{{codeNumber}}</v-col>
            </v-row>
        </v-container>

        <v-item-group>
            <v-container>
                <v-row justify="space-around">
                    <v-col
                            v-for="(code) of codes" :key="`code-${code.code}`"
                            cols="12"
                            sm="6"
                            md="4"
                            lg="3"
                            xl="2"
                    >
                        <v-item v-slot:default="{ active, toggle }">
                            <v-card
                                    height="200"
                                    @click="toggle"
                                    :color="cardColor(code)"
                                    :dark="darkCode(code)"
                                    hover
                                    class="title"
                            >
                                <v-row justify="center" align-content="center" class="fill-height">
                                    {{code.code}}

                                    <v-btn
                                            :color="canvasColor(code)"
                                            class="white--text"
                                            absolute
                                            right
                                            fab
                                            style="top:10px"
                                    >
                                        <v-icon>mdi-account-box</v-icon>
                                    </v-btn>
                                    <v-overlay
                                            absolute
                                            :value="active"
                                            color="purple"
                                            opacity="1"
                                            v-if="!code.found && search"
                                            z-index="2"
                                    >
                                        <v-row>
                                            <v-col cols="12" class="title text-center">
                                                {{code.code}}
                                            </v-col>
                                            <v-col cols="12" class="text-center">
                                                <v-btn color="success" @click="validerCode(code)">Valider</v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-overlay>
                                </v-row>


                            </v-card>
                        </v-item>
                    </v-col>

                </v-row>
            </v-container>
        </v-item-group>

        <v-dialog
        v-model="final"
        max-width="400px"
        >
            <v-card height="300px">
                <v-card-title>Vous avez perdu!</v-card-title>
                <v-card-text>Vous avez trouvé l'agent secret</v-card-text>
                <v-card-text class="text-center">
                    <v-icon size="120">mdi-emoticon-cry-outline</v-icon>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import JaroWinkler from '../../public/js/JaroWinkler';
    import axios from "axios";


    export default {
        name: "codename",
        data() {
            return {
                id: 2, // Give the players
                player: 3, // Current player => recover the player name
                search: true, // Determine if the player is searching or giving the code.
                codes: [],
                playing: true, // The game is currently playing.
                codeInput: '', // Code that will be given
                codeNumber: 2, // Nombre of code that must be found (goes for search and give)
                codeSearch: 'Troglodyte', // Search code
                codeFound: 0, // Number of code already found for this word,
                final: false
            }
        },
        computed: {
            codeSemblables() {
                let list = []

                for (let c of this.codes) {
                    if (c.found === 0) {
                        if (JaroWinkler.Distance(c.code, this.codeInput) > 0.9) {
                            list.push(c.code)
                        }
                    }
                }
                return (list.length > 0) ? `Codes semblables: ${list.join(', ')}` : '';
            }
        },
        methods: {
            validerCode(code) {
                code.found = 1;
                this.codeFound++;

                if(code.otherPlayer==='agent'){
                    this.final=true;
                }
            },
            cardColor(code) {
                // What I found from the other player
                return code.found ? this.colorCode(code.otherPlayer) : '';
            },
            canvasColor(code) {
                // My card color
                return this.colorCode(code.player)
            },
            colorCode(cardType) {
                if (cardType === 'team') {
                    return 'green lighten-2'
                }
                if (cardType === 'neutral') {
                    return 'brown lighten-3'
                }
                if (cardType === 'agent') {
                    return 'black'
                }
                return '';
            },
            darkCode(code) {
                return this.colorCode(code.otherPlayer) === 'black' && this.found;
            }
        },

        mounted() {

            // Create   POST
            // Read     GET
            // Update   PUT
            // Delete   DELETE

            // Generate the codes
            axios.get(`/api/codes`,
                {
                    params: {
                        id: this.$route.params['id']
                    }
                })
            .then(response=>this.codes = response.data.cards)
            .catch(function(error){
                console.log('ERREUR')
                console.log(error);
            }).then(function(){
                console.log('AXIOS TERMINATED');
            })

            /*this.codes = [
                {code: 'antagoniste', found: 0, player: 'team', otherPlayer: 'team'},
                {code: 'salade', found: 0, player: 'team', otherPlayer: 'neutral'},
                {code: 'barrière', found: 1, player: 'neutral', otherPlayer: 'neutral'},
                {code: 'enquête', found: 0, player: 'neutral', otherPlayer: 'agent'},
                {code: 'mortelle', found: 1, player: 'agent', otherPlayer: 'team'}
            ]*/
        }
    }
</script>

<style scoped>

</style>